export function normalizeApiData(data) {
  const normalizedData = Object.entries(data).map(([key, value]) => {
    if (value && key === '4') return { id: Number(key), value: value.format('DD.MM.YYYY') };

    return { id: Number(key), value };
  });

  return normalizedData;
}
